import React from "react";

const Logs = ({ callLogs }) => {
  const secondsToMinutes = (seconds) => {
    const minutes = Math.floor(seconds / 60);

    const remainingSeconds = seconds % 60;

    let formattedMinutes = "";
    if (minutes > 1) {
      formattedMinutes += `${minutes} minutes`;
    } else {
      if (minutes > 0) {
        formattedMinutes += `${minutes} minute`;
      }
    }
    let formattedSeconds = "";
    if (remainingSeconds > 1) {
      formattedSeconds += `${remainingSeconds} seconds`;
    } else {
      formattedSeconds += `${remainingSeconds} second`;
    }

    return `${formattedMinutes} ${formattedSeconds}`;
  };
  return (
    <table className="table table-bordered">
      <thead>
        <tr>
          <th>Duration</th>
          <th>Contact Name</th>
          <th>Contact Type</th>
          <th>Price</th>
        </tr>
      </thead>
      <tbody>
        {callLogs.length > 0 &&
          callLogs?.map((item, index) => (
            <tr key={item?._id}>
              <td>
                {item?.duration > 0 ? secondsToMinutes(item?.duration) : 0}
              </td>
              <td>
                {item?.contact_id?.length > 0 && item.contact_id[0]?.name}
              </td>
              <td>{item?.type}</td>
              <td>$ {item?.price ? item?.price : 0}</td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default Logs;
